// Central config — single source of truth for the backend URL.
// CRA embeds REACT_APP_* vars at build time from .env / .env.production.
// In Capacitor, if the env var is missing, fall back to production.

let _isNative = false;
try { _isNative = !!window.Capacitor?.isNativePlatform?.(); } catch {}

const PRODUCTION_URL = 'https://sharda-hr-system.emergent.host';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (_isNative ? PRODUCTION_URL : '');

export const API_URL = BACKEND_URL + '/api';
export const BACKEND_BASE = BACKEND_URL;
export const isNative = _isNative;

/** Returns today's date as YYYY-MM-DD in the user's LOCAL timezone (not UTC). */
export const getLocalDateStr = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
